/* Carrie theme — vanilla JS, no dependencies.
   Header overlays · variant picker · AJAX cart + drawer (Section Rendering API) · product recommendations · rails */
(function () {
  'use strict';
  const R = window.carrie || { routes: { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', root: '/' } };
  const $ = (s, el) => (el || document).querySelector(s);
  const $$ = (s, el) => Array.from((el || document).querySelectorAll(s));

  /* ── money ─────────────────────────────────────────── */
  function money(cents) {
    const fmt = R.money_format || 'RM {{amount}}';
    const n = (cents / 100).toFixed(2);
    const withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Whole ringgit without .00, as the Liquid money_without_trailing_zeros on the product page (2026-10-21)
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas.replace(/\.00$/, '')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/<[^>]+>/g, '');
  }

  /* ── toast ─────────────────────────────────────────── */
  let toastT;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(toastT);
    toastT = setTimeout(() => { t.hidden = true; }, 2200);
  }

  /* ── overlays: menu, cart drawer ───────────── */
  function lock(on) { document.body.style.overflow = on ? 'hidden' : ''; }
  function openEl(id) { const el = $(id); if (el) { el.hidden = false; lock(true); } return el; }
  function closeAll() { ['#mobile-nav', '#cart-drawer'].forEach(id => { const el = $(id); if (el) el.hidden = true; }); lock(false); }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-menu-open],[data-menu-close],[data-cart-open],[data-cart-close],[data-rail],[data-qty-change],[data-qty-step],[data-fold]');
    if (!t) return;
    const d = t.dataset;
    if ('menuOpen' in d) { openEl('#mobile-nav'); }
    else if ('fold' in d) { const c = t.closest('.fcol'); if (c) t.setAttribute('aria-expanded', c.classList.toggle('open')); }
    else if ('cartOpen' in d) { e.preventDefault(); openEl('#cart-drawer'); }
    else if ('menuClose' in d || 'cartClose' in d) { closeAll(); }
    else if (d.rail) { const head = t.closest('.sec-h'); const rail = head ? head.nextElementSibling : null; if (rail) rail.scrollBy({ left: +d.rail * ((rail.firstElementChild ? rail.firstElementChild.offsetWidth : 252) + 8), behavior: 'smooth' }); }
    else if (d.qtyChange !== undefined) { const line = t.closest('[data-line]'); if (line) { e.preventDefault(); changeLine(+line.dataset.line, +d.qtyChange); } }
    else if (d.qtyStep) { const q = t.closest('[data-qty]'); if (q) setQty(q, (+$('input', q).value || 1) + +d.qtyStep); }
  });
  /* product page quantity: 1 to its max (the per-size limit, else 99), "−" off at 1 */
  function setQty(q, n) {
    const input = $('input', q), max = +input.max || 99;
    n = Math.min(max, Math.max(1, Math.round(n) || 1));
    input.value = n;
    $('[data-qty-step="-1"]', q).disabled = n <= 1; $('[data-qty-step="1"]', q).disabled = n >= max;
  }
  document.addEventListener('change', e => { const q = e.target.closest('[data-qty]'); if (q) setQty(q, +e.target.value); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  /* phone gallery: the dot under the photo follows the swipe */
  document.addEventListener('scroll', e => {
    const g = e.target; if (!(g instanceof Element) || !g.classList.contains('gal')) return;
    const dots = g.parentElement.querySelector('.dots'); if (!dots || !g.clientWidth) return;
    const i = Math.round(g.scrollLeft / g.clientWidth);
    Array.from(dots.children).forEach((s, k) => s.classList.toggle('on', k === i));
  }, true);

  /* ── cart (AJAX) ───────────────────────────────────── */
  const SECTIONS = 'cart-drawer,header';
  // on the cart page its own section is re-rendered with the drawer (its id is on [data-cart-page])
  function cartSections() { const pg = $('[data-cart-page]'); return pg ? SECTIONS + ',' + pg.dataset.section : SECTIONS; }
  function applySections(sections) {
    if (!sections) return;
    const pg = $('[data-cart-page]');
    if (pg && sections[pg.dataset.section]) {
      const wrap = document.createElement('div'); wrap.innerHTML = sections[pg.dataset.section];
      const fresh = $('[data-cart-page]', wrap); if (fresh) pg.replaceWith(fresh);
    }
    if (sections['cart-drawer']) {
      const wrap = document.createElement('div'); wrap.innerHTML = sections['cart-drawer'];
      const fresh = $('#cart-drawer', wrap), cur = $('#cart-drawer');
      if (fresh && cur) { fresh.hidden = cur.hidden; cur.replaceWith(fresh); }
    }
    if (sections['header']) {
      const wrap = document.createElement('div'); wrap.innerHTML = sections['header'];
      const fp = $('#cart-pill', wrap), cp = $('#cart-pill');
      if (fp && cp) { cp.hidden = fp.hidden; cp.innerHTML = fp.innerHTML; }
      const fb = $('#cart-bubble', wrap), cb = $('#cart-bubble');
      if (fb && cb) { cb.textContent = fb.textContent; cb.hidden = fb.hidden; }
    }
  }
  async function addToCart(form) {
    const btn = $('[data-add-to-cart]', form); const txt = $('[data-add-text]', form);
    const old = txt ? txt.textContent : '';
    if (btn) btn.disabled = true; if (txt) txt.textContent = 'Adding…';
    try {
      const fd = new FormData(form); fd.append('sections', cartSections());
      // Bags per size per order (theme setting): count this variant's lines in the drawer, add only what is left
      const lim = +R.max_per_product || 0, vid = fd.get('id');
      let capped = '';
      if (lim > 0 && vid) {
        const have = $$('#cart-drawer [data-variant="' + vid + '"]').reduce((s, l) => s + (+l.dataset.qty || 0), 0);
        const room = lim - have, want = +fd.get('quantity') || 1;
        const msg = 'Limit ' + lim + ' bag' + (lim > 1 ? 's' : '') + ' of each size per order.';
        if (room <= 0) { toast(msg + ' You have ' + have + ' in your cart.'); return; }
        if (want > room) { fd.set('quantity', room); capped = msg + ' Added ' + room + '.'; }
      }
      const res = await fetch(R.routes.cart_add + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      if (!res.ok) { toast(data.description || data.message || 'Could not add to cart.'); return; }
      applySections(data.sections);
      openEl('#cart-drawer');
      if (capped) toast(capped);
    } catch (err) { toast('Could not add to cart. Check your connection.'); }
    finally { if (btn) btn.disabled = false; if (txt) txt.textContent = old; }
  }
  async function changeLine(line, quantity) {
    try {
      const res = await fetch(R.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity, sections: cartSections() }) });
      const data = await res.json();
      if (!res.ok) { toast(data.description || 'Could not update the cart.'); return; }
      applySections(data.sections);
    } catch (err) { toast('Could not update the cart.'); }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault(); addToCart(form);
  });

  /* ── variant picker ────────────────────────────────── */
  $$('[data-product-json]').forEach(script => {
    let variants = []; try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    const root = script.closest('.wrap') || document;
    const form = $('[data-product-form]', root); if (!form) return;
    const fieldsets = $$('.opt[data-option-index]', form);
    const idInput = $('[data-variant-id]', form);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root);
    const stockEl = $('[data-stock]', form), addBtn = $('[data-add-to-cart]', form), addTxt = $('[data-add-text]', form);

    function selected() { return fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; }); }
    function find(opts) { return variants.find(v => opts.every((o, i) => o === null || v.options[i] === o)); }
    function markAvailability() {
      const sel = selected();
      fieldsets.forEach((fs, i) => {
        $$('input', fs).forEach(input => {
          const probe = sel.slice(); probe[i] = input.value;
          const v = variants.find(x => probe.every((o, j) => o === null || x.options[j] === o));
          const label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      const v = find(selected());
      if (!v) { if (addBtn) addBtn.disabled = true; if (addTxt) addTxt.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      const sp = $('[data-sticky-price]'), sa = $('[data-sticky-add]');
      if (sp) sp.textContent = money(v.price);
      if (sa) { sa.disabled = !v.available; sa.textContent = v.available ? (addTxt && addTxt.dataset.preorder ? 'Pre-order' : 'Add to cart') : 'Sold out'; }
      if (addBtn) addBtn.disabled = !v.available;
      if (addTxt) addTxt.textContent = v.available ? (addTxt.dataset.preorder ? 'Pre-order' : 'Add to cart') : 'Sold out';
      if (stockEl) {
        const q = v.inventory_quantity; const managed = v.inventory_management === 'shopify';
        if (!v.available) stockEl.innerHTML = '';
        else if (!(managed && v.inventory_policy === 'continue' && q <= 0)) stockEl.innerHTML = '';
      }
      markAvailability();
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    fieldsets.forEach(fs => fs.addEventListener('change', update));
    markAvailability();
  });

  /* ── sticky buy bar (phones): shows once the main Add to cart is above the viewport.
     A position check on scroll/resize/load (not an IntersectionObserver change), so a restored scroll position
     or a fast fling past the button still shows it. ── */
  const sticky = $('[data-sticky]'), cartrow = $('.buy .cartrow');
  if (sticky && cartrow) {
    let on = null, queued = false;
    const check = () => { queued = false; const next = cartrow.getBoundingClientRect().bottom < 0; if (next === on) return; on = next; sticky.classList.toggle('show', on); sticky.inert = !on; document.body.classList.toggle('sb-on', on); };
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
    window.addEventListener('scroll', queue, { passive: true }); window.addEventListener('resize', queue); window.addEventListener('pageshow', check); check();
    const sa = $('[data-sticky-add]'); if (sa) sa.addEventListener('click', () => { const f = $('[data-product-form]'); if (f) addToCart(f); });
  }

  /* ── product columns (desktop): both are sticky (carrie.css); one taller than the screen gets a moving top, clamped between
     its CSS top (top edge held under the header) and the screen height less its own (bottom edge held 16px off the foot), so it
     scrolls with the page until an edge shows, then holds. The taller column has no room to stick, so this only moves the shorter. ── */
  const cols = $$('.pdp>.media, .pdp>.buy'), wide = window.matchMedia && matchMedia('(min-width:901px)');
  if (cols.length && wide) {
    let st = [], lastY = window.scrollY, queued = false;
    const measure = () => {
      st = cols.map(el => { const at = el.getBoundingClientRect().top; el.style.top = ''; const max = parseFloat(getComputedStyle(el).top) || 0;
        return { el, max, min: Math.min(max, window.innerHeight - el.offsetHeight - 16), at }; });
      lastY = window.scrollY; step();
    };
    const step = () => {
      queued = false; const d = window.scrollY - lastY; lastY = window.scrollY;
      if (!wide.matches) return;
      st.forEach(c => { if (c.min === c.max) return; const t = Math.max(c.min, Math.min(c.max, c.at - d));
        c.el.style.top = t + 'px'; c.at = c.el.getBoundingClientRect().top; });
    };
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(step); } };
    window.addEventListener('scroll', queue, { passive: true }); window.addEventListener('resize', measure); window.addEventListener('pageshow', measure);
    if (window.ResizeObserver) { const ro = new ResizeObserver(measure); cols.forEach(el => ro.observe(el)); } else measure();
  }

  /* ── scrollable tab rows get a fade when they overflow ── */
  function tabsFade() { $$('.tabs').forEach(t => t.classList.toggle('overflowing', t.scrollWidth > t.clientWidth + 2)); }
  tabsFade(); window.addEventListener('resize', tabsFade);

  /* ── gallery thumbs ────────────────────────────────── */
  $$('.thumbs .th').forEach((th, i) => th.addEventListener('click', () => { const shot = $$('.gal .shot')[i]; if (shot) shot.scrollIntoView({ behavior: 'smooth', block: 'center' }); $$('.thumbs .th').forEach(x => x.classList.remove('on')); th.classList.add('on'); }));

  /* ── lead form → opt-in: carry the email over the page reload so the opt-in field is pre-filled ── */
  const leadForm = $('#lead-form'), leadEmail = $('[data-lead-email]');
  if (leadForm) leadForm.addEventListener('submit', () => { try { sessionStorage.setItem('carrie-lead-email', (leadForm.querySelector('[type=email]') || {}).value || ''); } catch (e) { /* ignore */ } });
  if (leadEmail && !leadEmail.value) { try { leadEmail.value = sessionStorage.getItem('carrie-lead-email') || ''; } catch (e) { /* ignore */ } }

  /* ── collection sort menu (option B): a <details> drop-down; links do the sorting. Adds outside-click / Esc close and arrow keys ── */
  const sd = $('[data-sortd]');
  if (sd) {
    const sum = $('summary', sd), rows = () => $$('.rad', sd);
    const close = (refocus) => { if (!sd.open) return; sd.open = false; if (refocus) sum.focus(); };
    document.addEventListener('click', e => { if (sd.open && !sd.contains(e.target)) close(false); });
    sd.addEventListener('keydown', e => {
      if (!sd.open) return;
      if (e.key === 'Escape') { e.stopPropagation(); close(true); }
      else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { const r = rows(); let i = r.indexOf(document.activeElement); i = i < 0 ? 0 : (i + (e.key === 'ArrowDown' ? 1 : -1) + r.length) % r.length; r[i].focus(); e.preventDefault(); }
    });
  }

  /* ── wholesale machine field: one line that grows; CSS field-sizing does it where supported (Chrome), this where not (Safari) ── */
  if (!(window.CSS && CSS.supports('field-sizing', 'content'))) $$('.lf textarea').forEach(ta => ta.addEventListener('input', () => { ta.style.height = 'auto'; ta.style.height = ta.scrollHeight + ta.offsetHeight - ta.clientHeight + 'px'; }));

  /* ── wholesale volume picker (2026-10-29): the sort menu's list stands in for the select's own; picking a row sets the real select ── */
  $$('[data-pick]').forEach(pk => {
    const sel = $('select', pk), btn = $('.pick-btn', pk), list = $('.pick-list', pk), val = $('span', btn), rows = $$('[role=option]', pk);
    const lbl = $('label[for="' + sel.id + '"]');
    const open = (on, toRow) => {
      list.hidden = !on; btn.setAttribute('aria-expanded', on); pk.classList.toggle('open', on);
      if (on && toRow) (rows.find(r => r.classList.contains('on')) || rows[0]).focus();
    };
    const mark = r => {
      rows.forEach(x => { x.classList.toggle('on', x === r); x.setAttribute('aria-selected', x === r); });
      if (r) { val.textContent = r.textContent.trim(); btn.classList.add('set'); btn.classList.remove('bad'); }
    };
    const pick = r => { sel.value = r.dataset.value; sel.dispatchEvent(new Event('change', { bubbles: true })); mark(r); open(false); btn.focus(); };
    pk.classList.add('on'); btn.hidden = false; sel.tabIndex = -1;
    mark(rows.find(r => sel.value && r.dataset.value === sel.value)); // a value kept by the browser on Back
    if (lbl) lbl.addEventListener('click', e => { e.preventDefault(); btn.focus(); });
    btn.addEventListener('click', () => open(list.hidden, true));
    // a letter jumps to the next row that starts with it (S → Sabah, Sarawak, Selangor)
    const jump = (k, from) => { const n = rows.length, s = rows.indexOf(from); for (let j = 1; j <= n; j++) { const r = rows[(s + j + n) % n]; if (r.textContent.trim().toLowerCase().startsWith(k)) return r.focus(), true; } return false; };
    const letter = e => e.key.length === 1 && /\S/.test(e.key) && !e.ctrlKey && !e.metaKey && !e.altKey ? e.key.toLowerCase() : '';
    btn.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(true, true); }
      else if (letter(e)) { e.preventDefault(); open(true, true); jump(letter(e), document.activeElement); }
    });
    list.addEventListener('click', e => { const r = e.target.closest('[role=option]'); if (r) pick(r); });
    list.addEventListener('keydown', e => {
      const i = rows.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); rows[(i + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) pick(rows[i]); }
      else if (e.key === 'Escape') { e.stopPropagation(); open(false); btn.focus(); }
      else if (e.key === 'Tab') open(false);
      else if (letter(e)) { e.preventDefault(); jump(letter(e), document.activeElement); }
    });
    document.addEventListener('click', e => { if (!list.hidden && !pk.contains(e.target)) open(false); });
    sel.addEventListener('invalid', () => btn.classList.add('bad'));
  });

  /* ── hero and gallery videos: reduced motion starts paused on the poster frame; the button toggles play / pause ── */
  const vidOff = () => !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function vidSet(btn, off) {
    const v = $('video', btn.closest('.hero, .shot')); if (!v) return;
    if (off) v.pause(); else { v.muted = true; v.play().catch(() => {}); }
    btn.classList.toggle('off', off); btn.setAttribute('aria-label', (off ? 'Play' : 'Pause') + ' video');
  }
  $$('[data-vidpp]').forEach(b => { if (vidOff()) vidSet(b, true); });
  document.addEventListener('click', e => { const b = e.target.closest('[data-vidpp]'); if (b) vidSet(b, !b.classList.contains('off')); });

  /* ── lead film in the gallery (Brown Boys, 2026-10-23): plays once; in the phone swipe gallery it then moves on to the next shot,
     once. Swiped back to, it starts again and loops. Desktop (no swipe) loops. Out of view it waits; the pause button wins. ── */
  $$('[data-lead] video').forEach(v => {
    const shot = v.closest('.shot'), g = shot.parentElement, btn = $('[data-vidpp]', shot);
    let moved = false, seen = true;
    const swipes = () => g.scrollWidth > g.clientWidth + 1;
    const off = () => btn && btn.classList.contains('off');
    v.addEventListener('ended', () => {
      const next = shot.nextElementSibling;
      if (swipes() && !moved && next) { moved = true; g.scrollTo({ left: g.scrollLeft + next.getBoundingClientRect().left - shot.getBoundingClientRect().left, behavior: 'smooth' }); }
      else { v.currentTime = 0; if (!off()) v.play().catch(() => {}); }
    });
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting && !seen) { seen = true; if (moved) { v.loop = true; v.currentTime = 0; } if (!off()) v.play().catch(() => {}); }
      else if (!en.isIntersecting && seen) { seen = false; v.pause(); }
    }, { threshold: 0.6 }).observe(shot);
  });

  /* ── privacy policy: the Bahasa Malaysia notice (its h2 and all that follows) folds into one accordion at the top ── */
  $$('.shopify-policy__body .rte h2').forEach(h => {
    if (h.textContent.trim() !== 'Bahasa Malaysia') return;
    const rte = h.parentNode, acc = document.createElement('div'), d = document.createElement('details'), body = document.createElement('div');
    acc.className = 'acc lang'; body.className = 'body'; body.lang = 'ms';
    d.innerHTML = '<summary>Bahasa Malaysia</summary>';
    while (h.nextSibling) body.appendChild(h.nextSibling);
    const hr = h.previousElementSibling; if (hr && hr.tagName === 'HR') hr.remove();
    h.remove(); d.appendChild(body); acc.appendChild(d); rte.prepend(acc);
  });

  /* ── product recommendations (Section Rendering API) ─ */
  $$('[data-recommendations]').forEach(async el => {
    if (window.innerWidth < 900) return; // hidden on phones (Complete the shelf covers it)
    try {
      const res = await fetch(el.dataset.url); if (!res.ok) return;
      const html = await res.text(); const wrap = document.createElement('div'); wrap.innerHTML = html;
      const inner = $('[data-recommendations] .wrap', wrap); if (inner && inner.children.length) el.replaceChildren(inner);
    } catch (e) { /* leave empty */ }
  });
})();
